import { Link, useParams } from 'react-router-dom';
import { ACCESS_TOKEN } from '../constants';
import api from '../api';
import { useState, useEffect } from 'react';
import NotFound from './Notfound';
import '../styles/user.css';
const apiEndpoint = process.env.REACT_APP_API_URL;

function User() {
  const { username } = useParams();
  const acces = localStorage.getItem(ACCESS_TOKEN)
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [show, setShow] = useState(false);
  const [link, setLink] = useState('');

  const getProfile = async () => {
    try {
      const res = await api.post('api/profile_data/', { username });
      setProfile(res.data);
      document.title = `${username}`;
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const addDialogue = async () => {
    try {
      const res = await api.post('api/add_dialogue/', { username });
      if (res.status === 200) {
        window.location.href = `/chats`;
      }

    }
    catch (error) {
    }
  }

  function RenderSocials() {
    return (<>
      {profile.socials.map((item, index) => (

        <div key={index} onClick={() => window.open(item.link, "_blank")} className={`container mt-4 centered-div ${item.social_media}`}>
          <div className="d-flex align-items-center position-relative">
            <img src={`${apiEndpoint}/media/icons/${item.social_media}.png`} alt="Profil Fotoğrafı" className="profile-pic me-3" />


            <div className="container">

              <p style={{ marginBottom: "0" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                </svg> : {item.followers}
              </p>


              <p style={{ marginBottom: "0" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className=" p-0 m-0 bi bi-globe2" viewBox="0 0 16 16">
                  <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
                </svg> :

                {item.countrys.map((country, countryIndex) => (
                  <span className="countrys" key={countryIndex}> {country.name} </span>
                ))}
              </p>

              <p style={{ marginBottom: "0" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags" viewBox="0 0 16 16">
                  <path d="M3 2v4.586l7 7L14.586 9l-7-7zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586z" />
                  <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1z" />
                </svg> :

                {item.tags.map((country, countryIndex) => (
                  <span className="tags" key={countryIndex}> {country.name} </span>
                ))}
              </p>

            </div>
          </div>
        </div>

      ))}
    </>
    )
  }

  function RenderLinks() {
    return (
      <div className=" mt-5">
        <hr />
        {/* <h5 className="slogan_u mt-5 mb-0 pb-2">Links:</h5> */}
        {profile.links.map((item, index) => (
          <div
            key={index}
            onClick={() => window.open(item.link, "_blank")}
            className={`container mt-4 centered-div ${item.social_media} position-relative `}
          >
            <div className="d-flex align-items-center justify-content-center position-relative w-100">
              <img
                src={`${apiEndpoint}/media/icons/link.png`}
                alt="Profil Fotoğrafı"
                className="profile-pic"
                style={{ width: "50px", height: "50px" }}
              />
              <div style={{ marginLeft: "-13px", marginRight: "28px" }} className="flex-grow-1 text-center">
                {item.title}
                {item.title}
                {item.title}
              </div>

              {/* Üç nokta butonu */}
              <div
                className="clickable-area position-absolute end-0 me-1"
                onClick={(e) => {
                  e.stopPropagation();
                  handleShow(item.link);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-icon"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>

    );
  }

  const handleClose = () => {
    setShow(false);
  }

  const handleShow = (link) => {
    setLink(link);
    setShow(true);
  }

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!profile) {
    return <NotFound />;
  }
  else {
    return (<>
      {/* <div className='full-heightuser' style={{ backgroundColor: profile.profile.background_color }} > */}
      <div className='full-heightuser' >

        <div className="container d-flex flex-column justify-content-end align-items-center mb-5 ">
          <div className='mb-3' ></div>
          <div className='mb-3' ></div>

          {/* pp */}
          <div className="mb-3 position-relative">
            <div className="profile-wrapper" style={{ position: "relative", display: "inline-block" }}>
              <img
                className="profile-icon"
                src={profile.profile.profile_picture}
                alt="profile"
                style={{ width: "80px", height: "80px", borderRadius: "50%" }}
              />

              {profile.profile.is_content_producer && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="#49AFFE"
                  viewBox="0 0 16 16"
                  style={{
                    position: "absolute",
                    bottom: "0px",
                    right: "0px",
                    transform: "translate(30%, 30%)", // biraz üstüne gelsin diye
                    backgroundColor: "white",

                    padding: "2px"
                  }}
                >
                  <path d="M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                  <path d="M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM1 3a1 1 0 0 1 1-1h2v2H1zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3zm-4-2h3v2H2a1 1 0 0 1-1-1zm3-1H1V8h3zm0-3H1V5h3z" />
                </svg>
              )}
            </div>
          </div>


          {/* contact button */}
          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center align-items-center mb-3">
            <h2 className='name'>{username}</h2>
            {acces ? (
              <button style={{ fontSize: "20px" }} onClick={addDialogue} className="navbtns d-grid gap-2" type="button">
                Contact
              </button>
            ) : (
              <Link to="/login" style={{ fontSize: "20px" }} className="navbtns d-grid gap-2" >
                <span className='mx-2'>Contact</span>
              </Link>
            )}
          </div>


          {/* countrys and tags */}
          {(profile.profile.countrys.length > 0 || profile.profile.tags.length > 0) &&
            // <div className='asd mb-3 borderdiv'>
            <div className='asd mb-3 '>
              {profile.profile.countrys && profile.profile.countrys.length > 0 && (
                <p style={{ marginBottom: "0" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className=" p-0 m-0 bi bi-globe2" viewBox="0 0 16 16">
                    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
                  </svg> :

                  {profile.profile.countrys.map((country, countryIndex) => (
                    <span className="countrys" key={countryIndex}> {country.name} </span>
                  ))}
                </p>)}
              {profile.profile.tags && profile.profile.tags.length > 0 && (

                <p style={{ marginBottom: "0" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags" viewBox="0 0 16 16">
                    <path d="M3 2v4.586l7 7L14.586 9l-7-7zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586z" />
                    <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1z" />
                  </svg> :

                  {profile.profile.tags.map((country, countryIndex) => (
                    <span className="tags" key={countryIndex}> {country.name} </span>
                  ))}
                </p>)}
            </div>
          }

          {/* profile text */}
          <div className={`container  bio`}>
            <div className=" align-items-center position-relative ">
              <div>
                {profile.profile.profile_text}
              </div>
            </div>
          </div>




          {/* className='mb-3 borderdiv' */}
          <RenderSocials />

          <RenderLinks />

          {/* link show */}
          {show && (
            <div className="modal fade show overlay" tabIndex="-1" role="dialog" >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5 text-wrap text-break" id="exampleModalLabel">{link}</h1>

                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-danger" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

    </>
    );
  }
}
export default User;